import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('upload_documents'),
    uploadButtonTitle: defineMessage('upload'),
    fileToUploadButtonSectionTitle: defineMessage('file_type_to_upload'),
    bulkUploadDocumentSuccess: defineMessage('numberdocuments_new_tem_ly_if_you_dont_see_them'),
    multipleAttachmentsWarning: defineMessage('note_approvalmax_will_c_rationtype_templatename'),
};
